export const sentryInstallationViewSample = {
  'action': 'created',
  'actor': {
    'id': 1,
    'name': 'Meredith Heller',
    'type': 'user'
  },
  'data': {
    'installation': {
      'status': 'pending',
      'organization': {
        'slug': 'test-org'
      },
      'app': {
        'uuid': '2ebf071f-28df-4989-aca9-c37c763b278f',
        'slug': 'webhooks-galore'
      },
      'code': 'f3c71b491e3949b6b033ae45312a4fcb',
      'uuid': 'a8e5d37a-696c-4c54-adb5-b3f28d64c7de'
    }
  },
  'installation': {
    'uuid': 'a8e5d37a-696c-4c54-adb5-b3f28d64c7de'
  }
}
;

  export const sentryInstallationSample = {
    'action': 'created',
    'data::installation::app.slug': 'webhooks-galore',
    'data::installation::app.uuid': '2ebf071f-28df-4989-aca9-c37c763b278f',
    'actor.name': 'Meredith Heller',
  };
  


// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/sentry_installation.ts